import { EmailIcon } from './EmailIcon';

/**
 * author: Google
 * id 14AAE073-8399-4D67-9F7E-8E9424328681
 * name email
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email.svg
 * tags
 */
export const MarkunreadIcon = EmailIcon;
export default MarkunreadIcon